import React from 'react';
import cx from 'classnames';

import styles from './divider.module.scss';

import type * as Polymorphic from './polymorphic';

// eslint-disable-next-line @typescript-eslint/ban-types
type DividerProps = {};

export const Divider = React.forwardRef(function Divider(
    { as, className, children, ...props },
    forwardRef
) {
    const Component = as ?? (children ? 'div' : 'hr');
    const role = Component !== 'hr' ? 'separator' : undefined;

    return (
        <Component
            className={cx(styles.component, className)}
            ref={forwardRef}
            role={role}
            {...props}>
            {children ? (
                <span className="d-inline-block px-2">{children}</span>
            ) : null}
        </Component>
    );
}) as Polymorphic.ForwardRefComponent<'hr', DividerProps>;
